import { Blob } from "blob-polyfill"

export default Blob
